
export enum SessionStatus { 
    notFound = 0,
    notStarted = 1,
    started = 2,
    ended = 3
}

